import React from 'react';
import { Text } from '@beef/ui-kit';
export var AddressSectionTitle = function AddressSectionTitle(_ref) {
  var city = _ref.city,
    region = _ref.region;
  return /*#__PURE__*/React.createElement("div", {
    className: "mar-b-m",
    "data-t-id": "components-AddressSectionTitle"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey60",
    size: "size5-r-s"
  }, city), ' ', /*#__PURE__*/React.createElement(Text, {
    size: "size5-m"
  }, region));
};